/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MissingDataStatus = {
    NotSpecified: 'NotSpecified',
    SendFailed: 'SendFailed',
    MissingValues: 'MissingValues',
    MissingDataReceived: 'MissingDataReceived',
    ValidationError: 'ValidationError',
    MissingFormula: 'MissingFormula',
    MissingCalculationRequirement: 'MissingCalculationRequirement',
    EstimationFailed: 'EstimationFailed',
    MissingEstimationGroup: 'MissingEstimationGroup',
    InfiniteCalculationLoop: 'InfiniteCalculationLoop',
    CalculationResolutionMismatch: 'CalculationResolutionMismatch',
    CalculationFailed: 'CalculationFailed',
    EstimatedValues: 'EstimatedValues',
    EstimationCandidate: 'EstimationCandidate',
    FailedAddMeteredData: 'FailedAddMeteredData',
    ReestimationCandidate: 'ReestimationCandidate',
} as const;
export type MissingDataStatus = typeof MissingDataStatus[keyof typeof MissingDataStatus];

